module.exports = __webpack_public_path__ + "assets/confirmation_number.555770b8bde3cd730ca634ec861a1a73.svg";